/*
 * Black Week countdowns and teaser → live switch.
 * Config comes from layout/theme.liquid: window.STYLER_BW = { start, end, force, lang }.
 *
 *   [data-bw-countdown]            text countdown, e.g. "5д 12:04:33"
 *   [data-bw-countdown-blocks]     boxes; children [data-bw-d] [data-bw-h] [data-bw-m] [data-bw-s]
 *   [data-bw-when="teaser|live"]   shown only in that state
 *
 * Countdowns target the start while in teaser, the end while live. Elements
 * added later (variant change re-renders the price box, AJAX filters) are
 * picked up on the next tick, so nothing has to re-initialise them.
 */
(function () {
  var cfg = window.STYLER_BW;
  if (!cfg || !cfg.end) return;
  var dayUnit = cfg.lang === "en" ? "d" : "д";
  var pad = function (n) { return (n < 10 ? "0" : "") + n; };

  function state(now) {
    if (now >= cfg.end) return "ended";
    if (cfg.force || now >= cfg.start) return "live";
    return "teaser";
  }

  var lastState = null;
  function tick() {
    var now = Date.now();
    var s = state(now);
    if (s !== lastState) {
      document.documentElement.setAttribute("data-bw-state", s);
      var whens = document.querySelectorAll("[data-bw-when]");
      for (var i = 0; i < whens.length; i++) whens[i].hidden = whens[i].getAttribute("data-bw-when") !== s;
      lastState = s;
    }
    var target = s === "teaser" ? cfg.start : cfg.end;
    var left = Math.max(0, Math.floor((target - now) / 1000));
    var d = Math.floor(left / 86400);
    var h = Math.floor((left % 86400) / 3600);
    var m = Math.floor((left % 3600) / 60);
    var sec = left % 60;
    var text = (d > 0 ? d + dayUnit + " " : "") + pad(h) + ":" + pad(m) + ":" + pad(sec);

    var els = document.querySelectorAll("[data-bw-countdown]");
    for (var j = 0; j < els.length; j++) if (els[j].textContent !== text) els[j].textContent = text;

    var blocks = document.querySelectorAll("[data-bw-countdown-blocks]");
    for (var k = 0; k < blocks.length; k++) {
      var b = blocks[k];
      var set = function (sel, v) { var e = b.querySelector(sel); if (e) e.textContent = v; };
      set("[data-bw-d]", pad(d));
      set("[data-bw-h]", pad(h));
      set("[data-bw-m]", pad(m));
      set("[data-bw-s]", pad(sec));
    }
  }

  // Keep the chosen pill / tile in view in the side-scrolling rows on phones. The
  // rows are new elements after every AJAX filter change, hence the flag.
  function revealActivePills() {
    var rows = document.querySelectorAll("#BwFilterBar .bw-filters__row:not([data-bw-seen]), #BwCatTiles .bw-tiles__row:not([data-bw-seen])");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      row.setAttribute("data-bw-seen", "");
      var active = row.querySelectorAll(".bw-pill--active, .bw-tile--active");
      var last = active[active.length - 1];
      if (!last || row.scrollWidth <= row.clientWidth) continue;
      // Only when the chosen one is (partly) out of view; measured on screen
      // because the sticky category row is its pills' offsetParent.
      var lr = last.getBoundingClientRect();
      var rr = row.getBoundingClientRect();
      if (lr.left < rr.left || lr.right > rr.right) {
        row.scrollLeft += lr.left - rr.left - 16;
      }
    }
  }

  // Black Week page: once the category photo tiles have scrolled above the
  // screen, the sticky bar shows its compact category row (CSS keys off
  // html.bw-tiles-out), so categories stay one tap away while browsing.
  // #BwCatTiles itself is never replaced (facets.js swaps its contents).
  var tiles = document.getElementById("BwCatTiles");
  if (tiles && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var out = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      document.documentElement.classList.toggle("bw-tiles-out", out);
    }).observe(tiles);
  }

  // A new category or discount picked further down the page: go back to the
  // first product, so the best deals of the new choice are what they see.
  if (tiles) {
    document.addEventListener("click", function (e) {
      var link = e.target.closest && e.target.closest("#BwFilterBar a, #BwCatTiles a");
      if (!link) return;
      // +2: just past the tiles, so the sticky category row stays on.
      var gridTop = tiles.getBoundingClientRect().bottom + window.scrollY + 2;
      if (window.scrollY > gridTop + 10) window.scrollTo({ top: gridTop, behavior: "smooth" });
    });
  }

  tick();
  revealActivePills();
  setInterval(function () { tick(); revealActivePills(); }, 1000);
})();
